import { indexData } from '@/mocks/home';

export default function IndexSection() {
  return (
    <section id="index" className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="mb-8 md:mb-10">
          <h2 className="text-xl md:text-2xl font-extrabold text-foreground-900">主题索引</h2>
          <p className="text-sm text-foreground-600 mt-2">按类型快速浏览91视频的海量影视资源，找到你最爱的内容分类</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {indexData.map((item) => (
            <a
              key={item.id}
              href="#"
              onClick={(e) => e.preventDefault()}
              className="group bg-background-100 rounded-xl p-5 border border-background-200/70 hover:border-primary-200 hover:bg-background-50 transition-all duration-200 text-center cursor-pointer"
            >
              <div className="w-12 h-12 rounded-xl bg-primary-100 flex items-center justify-center mx-auto mb-3 group-hover:bg-primary-200 transition-colors">
                <i className={`${item.icon} text-primary-600 text-xl`}></i>
              </div>
              <h3 className="text-sm md:text-base font-bold text-foreground-900 mb-1 whitespace-nowrap">{item.title}</h3>
              <p className="text-xs text-foreground-500 mb-2">{item.desc}</p>
              <span className="text-xs font-semibold text-primary-600">{item.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}